import script from "./ItemMenuWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemMenuWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ItemMenuWrapper.vue?vue&type=style&index=0&id=b2079d02&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2079d02"]])

export default __exports__